import React, { useEffect, useState, useRef } from 'react';
import { Link } from 'react-router-dom';
import classNames from 'classnames';
//configs
import { PAGE_NAV } from 'configs/page';
import { MENUS } from 'configs/page';
//layout
import LoggedInLayout from 'layouts/LoggedInLayout';
//hooks
import { useRecoilState } from 'recoil';
import { dashboardCampaignSelectionAtom, dashboardSelectedMonthAtom } from 'recoil/stats/dashboardFilters';
import useLeftMenu from 'hooks/useLeftMenu';
import useAccount from 'hooks/useAccount';
import useCampaigns from 'hooks/useCampaigns';
import useCampaignsSummary from 'hooks/useCampaignsSummary';
import useTotalEarnings from 'hooks/useTotalEarnings';
import { useCampaignDailyBreakdown, useAllCampaignsDailyBreakdown } from 'hooks/useDailyBreakdown';
//components
import CampaignList from 'components/CampaignListNew';
//utils
import { currencyFormatterNoDigit as formatter } from 'utils/formatter';
import moment from 'moment';
//icons
import EmptyStateGraphic from 'assets/img/dashboard-empty.png'
import calendarClock from 'assets/img/calendar-clock.svg';
import usrsIco from 'assets/img/users-round.svg';
import trendingIco from 'assets/img/trending-up.svg'
import Skeleton from "react-loading-skeleton";
import LinkToRHPAccountLink from 'components/LinkToRHPAccountLink';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faInfoCircle } from "@fortawesome/free-solid-svg-icons";

const AffiliateDashboard = (props) => {
    const { data: earningsSummary, isLoading: earningsLoading, isError: earningsError } = useTotalEarnings();
    const { rhpLinkAcc } = useAccount();

    const [leftMenu, setLeftMenu] = useLeftMenu();
    const accountProvider = useAccount();
    const { profiles } = accountProvider;
    const mountedRef = useRef(true);
    const { dateRangeID } = useCampaigns();
    const { data: campaignList } = useCampaignsSummary(dateRangeID);

    // Recoil atoms keep these selections alive across navigation
    const [campaignSelectionValue, setCampaignSelectionValue] = useRecoilState(dashboardCampaignSelectionAtom);
    const [selectedMonth, setSelectedMonth] = useRecoilState(dashboardSelectedMonthAtom);

    const queryDate = moment(selectedMonth, "YYYY/MM/DD");
    const queryYear = queryDate.year();
    const queryMonth = queryDate.month() + 1;
    const isAllCampaigns = campaignSelectionValue < 1;

    const { data: allData, isFetching: allFetching } =
        useAllCampaignsDailyBreakdown(queryYear, queryMonth);
    const { data: singleData, isFetching: singleFetching } =
        useCampaignDailyBreakdown(campaignSelectionValue, queryYear, queryMonth);

    const breakdownData = isAllCampaigns ? allData : singleData;
    const isFetching    = isAllCampaigns ? allFetching : singleFetching;

    const joins    = breakdownData ? breakdownData.reduce((acc, r) => acc + r.Joins,    0) : 0;
    const upgrades = breakdownData ? breakdownData.reduce((acc, r) => acc + r.Upgrades, 0) : 0;

    useEffect(() => {
        return () => { mountedRef.current = false; };
    }, []);

    useEffect(() => {
        if (leftMenu.value !== "DASHBOARD" && mountedRef.current)
            setLeftMenu(MENUS.find(menu => menu.value === "DASHBOARD"));
    }, [leftMenu, setLeftMenu]);

    const [showNote, setShowNote] = useState(false);

    return (
        <LoggedInLayout {...props} 
        /*subPageTitle="Here's what's happening in your affiliate account."*/
        >
            {
                campaignList
                && campaignList.StatsSummaries
                && campaignList.StatsSummaries.length === 0
                &&
                <div className="empty-state">
                    <p className="empty-ghc"><img src={EmptyStateGraphic} alt="Empty state graphic" /></p>
                    <p className="empty-msg">LET'S GET THE BALL ROLLING</p>
                    <p className="sub">Creating and launching a campaign is pretty easy and we'll guide you through the process.</p>
                    <p className="grey btn link"><Link to={PAGE_NAV.CAMPAIGN_ADD} title="Add campaign">Create promotional link</Link></p>
                </div>
            }
            {
                campaignList
                && campaignList.StatsSummaries
                && campaignList.StatsSummaries.length > 0
                &&
                <>
                
                {/* <div className='mobile-page-header'>
                    <h1>Dashboard</h1>
                    <p class="sub-page-title">Here's what's happening in your affiliate account.</p>
                </div> */}
                
                <div className={classNames("section", "summary", "card-group")}>

                    {earningsLoading && <div></div>}

                    {
                        earningsError
                        && <>
                            <div className="card">
                                <div className="card-header">
                                    <h3>Next Payment</h3>
                                </div>
                                <div className="card-content">
                                    <p className="value">$0</p>
                                    <p className="go-to-link"><span>Expected payment date</span><span className="date">XX XXXX XXXX</span></p>
                                </div>
                            </div>
                            </>
                    }
                    {
                        earningsSummary
                        && <>
                            <div className={classNames("card", "earnings")}>
                                <div className="card-header">
                                    <h3><span className='heading-ico ico-rounded'><img src={calendarClock} title="Icon" /></span> <span className='heading-text'>Next Payment</span></h3>
                                    <p className="date">{(moment().date() < 16 ? moment() : moment().startOf('month').add(1, 'M')).format("15 MMMM YYYY")}</p>
                                </div>
                                <div className="card-content">
                                    <p translate="no"  className="value notranslate">{formatter.format(parseInt(earningsSummary.OutstandingBalance))}.<small className='decimal'>{parseInt((earningsSummary.OutstandingBalance % 1).toFixed(2).substring(2))}</small></p>
                                </div>
                                <div className='card-footer'>
                                    <dl className="total-earings">
                                        <dt className='tooltip'>Referral earnings 
                                            <span className='tooltip-ico' onMouseEnter= {()=>setShowNote(true)} onMouseLeave={()=>setShowNote(false)}><FontAwesomeIcon icon={faInfoCircle} /></span>
                                            {showNote && <em className='tooltip-bubble'>Referral Program<br /> When you refer a new affiliate to our system, you can receive an extra 10% of their earnings.<br /> Get in contract with our team to set up your referral program</em>}
                                        </dt>
                                        <dd translate="no"  className="notranslate">{formatter.format(parseInt(earningsSummary.OutstandingBalance))}</dd>
                                    </dl>
                                    
                                </div>
                            </div>

                            <div className={classNames("section", "users-sales", "card-group")}>
                                <div className={classNames("card", "new-user")}>
                                    <div className="card-content">
                                        <div className='raw'>
                                            <p className='people-ico ico-rounded'><img src={usrsIco} alt="people icon" /></p>
                                            <p className="date">{moment(selectedMonth).format("MMM YYYY")}</p>
                                        </div>
                                        
                                        <p className="value">
                                            {isFetching
                                                ? <span className="number"><Skeleton /></span>
                                                : <span className="number">{joins > 0 ? joins : '-'}</span>
                                            }
                                            <small className="sub">New users</small>
                                        </p>
                                    </div>
                                </div>
                                <div className={classNames("card", "sale")}>
                                    <div className="card-content">
                                        <div className='raw'>
                                            <p className='trending-ico ico-rounded'><img src={trendingIco} alt="Trending icon" /></p>
                                            <p className="date">{moment(selectedMonth).format("MMM YYYY")}</p>
                                        </div>
                                        
                                        <p className="value">
                                            {isFetching
                                                ? <span className="number"><Skeleton /></span>
                                                : <span className="number">{upgrades > 0 ? upgrades : '-'}</span>
                                            }
                                            <small className="sub">Sales</small>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </>
                    }

                </div>

                {
                    !rhpLinkAcc?.Username && 
                    <div className='link-account section card-group'>
                    <div className='card'>
                        <div className='card-header'>
                        <h3>Link RHP account</h3>
                        <LinkToRHPAccountLink cls="input-link">Link RHP Account</LinkToRHPAccountLink>
                        </div>
                    </div>
                </div>
                }
                

                <CampaignList
                    campaignSelectionValue={campaignSelectionValue}
                    onCampaignSelectionChange={setCampaignSelectionValue}
                    selectedMonth={selectedMonth}
                    onMonthChange={setSelectedMonth}
                    breakdownData={breakdownData}
                    isFetching={isFetching}
                />
                </>
            }
        </LoggedInLayout>
    );
};

export default AffiliateDashboard;
